import React, {Fragment, useEffect} from "react";
import styled from "@emotion/styled";

import {p, w100} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {upperFirst} from "@pg-mono/nodash";
import {areaFormat, pluralize, priceFormat} from "@pg-mono/string-utils";

import {CloseIconButton} from "../../../atoms/CloseIconButton";
import {IRegionListMap} from "../../../region/types/IRegionListMap";
import {getGeneratedDescriptionRooms} from "../utils/get_generated_description_rooms";
import {getRoomDisplayText} from "../utils/get_room_display_text";
import {MapGeneratedDescriptionFloors} from "./MapGeneratedDescriptionFloors";

interface IProps {
    generatedDescriptionAllowed: boolean;
    onHideGenericDescription: () => void;
    region: IRegionListMap;
    showGeneratedDescription: boolean;
}

const vendors = pluralize(["deweloper", "deweloperów", "deweloperów"]);
const flats = pluralize(["mieszkanie gotowe do odbioru", "mieszkania gotowe do odbioru", "mieszkań gotowych do odbioru"]);

export const MapGeneratedDescription = (props: IProps) => {
    const {region} = props;

    useEffect(() => {
        return () => {
            props.onHideGenericDescription();
        };
    }, []);

    const getRoomsWithAmount = (rooms: string, amount: number) => {
        return `${Number(rooms) !== 1 ? "mieszkania" : ""} ${getRoomDisplayText(Number(rooms))} (${amount})`;
    };

    const roomRanges = getGeneratedDescriptionRooms(region.stats.properties_flats_rooms_ranges);

    return props.generatedDescriptionAllowed ? (
        <Description visible={props.showGeneratedDescription}>
            <CloseIconButton onClick={props.onHideGenericDescription} right={3} top={3} />

            <Text as="div" variant="body_copy_2">
                <p>Jesteś zainteresowany zakupem nieruchomości w konkretnej lokalizacji, jednak chcesz poznać również okoliczne inwestycje?</p>
                <p>Dzięki naszej mapie porównasz i zlokalizujesz oferty mieszkań z rynku pierwotnego.</p>
                <p>
                    Co się buduje {region.name_declension_where}? Na mapie inwestycji deweloperskich znajdziesz {region.stats.properties_flats_count_for_sale}{" "}
                    ofert nowych mieszkań. Inwestycje buduje {region.stats.vendors_count_for_sale} {vendors(region.stats.vendors_count_for_sale)}. W sprzedaży
                    są:
                </p>
                <ul>
                    {Object.entries(roomRanges).map(([rooms, amount]) => {
                        return <li key={rooms}>{getRoomsWithAmount(rooms, amount)}</li>;
                    })}
                </ul>
                <p>Jak prezentują się statystyki dotyczące inwestycji deweloperskich w okolicy?</p>
                <p>
                    {!!region.stats.properties_flats_top_vendors.length &&
                        `Najwięcej mieszkań na sprzedaż oferuje ${region.stats.properties_flats_top_vendors.map(({name}) => name).join(", ")}. `}
                    Najmniejsze mieszkanie na mapie ma powierzchnię {areaFormat(region.stats.properties_flats_ranges_area_min)}, a największe{" "}
                    {areaFormat(region.stats.properties_flats_ranges_area_max)}.
                    {!!region.stats.average_price_m2 &&
                        `Średnia cena mieszkania ${region.name_declension_where} wynosi ${priceFormat(region.stats.average_price_m2)} za metr kwadratowy`}
                </p>
                <p>Ile kosztują nieruchomości w wybranym regionie?</p>
                <p>
                    {!!region.stats.properties_flats_ranges_price_min &&
                        `Najtańsze mieszkanie kupimy za ${priceFormat(region.stats.properties_flats_ranges_price_min)}. `}

                    {!!region.stats.properties_flats_ranges_price_max &&
                        `Za najdroższy lokal mieszkalny trzeba zapłacić ${priceFormat(region.stats.properties_flats_ranges_price_max)}.`}
                </p>
                <p>Ile gotowych mieszkań jest dostępnych w ofercie deweloperskiej?</p>
                <p>
                    {upperFirst(region.name_declension_where)}{" "}
                    {!!region.stats.properties_flats_count_ready ? (
                        <Fragment>
                            deweloperzy mają {region.stats.properties_flats_count_ready} {flats(region.stats.properties_flats_count_ready)}.
                        </Fragment>
                    ) : (
                        "nie ma mieszkań gotowych do odbioru."
                    )}
                </p>

                <MapGeneratedDescriptionFloors region={region} />
            </Text>
        </Description>
    ) : null;
};

const Description = styled.div<{visible: boolean}>`
    background-color: #fff;
    ${w100};
    min-height: calc(100% - 6.4rem);
    position: absolute;
    top: 0;
    right: 0;
    ${p(4, 3)};
    visibility: ${(props) => (props.visible ? "visible" : "hidden")};
    overflow: auto;
    max-height: 100%;
    z-index: 1;

    @media (min-width: ${(props) => props.theme.breakpoints.md}) {
        min-width: 57.3rem;
        width: 42%;
    }
`;
import React, {Fragment, useEffect} from "react";
import styled from "@emotion/styled";

import {p, w100} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {upperFirst} from "@pg-mono/nodash";
import {areaFormat, pluralize, priceFormat} from "@pg-mono/string-utils";

import {CloseIconButton} from "../../../atoms/CloseIconButton";
import {IRegionListMap} from "../../../region/types/IRegionListMap";
import {getGeneratedDescriptionRooms} from "../utils/get_generated_description_rooms";
import {getRoomDisplayText} from "../utils/get_room_display_text";
import {MapGeneratedDescriptionFloors} from "./MapGeneratedDescriptionFloors";

interface IProps {
    generatedDescriptionAllowed: boolean;
    onHideGenericDescription: () => void;
    region: IRegionListMap;
    showGeneratedDescription: boolean;
}

const vendors = pluralize(["deweloper", "deweloperów", "deweloperów"]);
const flats = pluralize(["mieszkanie gotowe do odbioru", "mieszkania gotowe do odbioru", "mieszkań gotowych do odbioru"]);

export const MapGeneratedDescription = (props: IProps) => {
    const {region} = props;

    useEffect(() => {
        return () => {
            props.onHideGenericDescription();
        };
    }, []);

    const getRoomsWithAmount = (rooms: string, amount: number) => {
        return `${Number(rooms) !== 1 ? "mieszkania" : ""} ${getRoomDisplayText(Number(rooms))} (${amount})`;
    };

    const roomRanges = getGeneratedDescriptionRooms(region.stats.properties_flats_rooms_ranges);

    return props.generatedDescriptionAllowed ? (
        <Description visible={props.showGeneratedDescription}>
            <CloseIconButton onClick={props.onHideGenericDescription} right={3} top={3} />

            <Text as="div" variant="body_copy_2">
                <p>Jesteś zainteresowany zakupem nieruchomości w konkretnej lokalizacji, jednak chcesz poznać również okoliczne inwestycje?</p>
                <p>Dzięki naszej mapie porównasz i zlokalizujesz oferty mieszkań z rynku pierwotnego.</p>
                <p>
                    Co się buduje {region.name_declension_where}? Na mapie inwestycji deweloperskich znajdziesz {region.stats.properties_flats_count_for_sale}{" "}
                    ofert nowych mieszkań. Inwestycje buduje {region.stats.vendors_count_for_sale} {vendors(region.stats.vendors_count_for_sale)}. W sprzedaży
                    są:
                </p>
                <ul>
                    {Object.entries(roomRanges).map(([rooms, amount]) => {
                        return <li key={rooms}>{getRoomsWithAmount(rooms, amount)}</li>;
                    })}
                </ul>
                <p>Jak prezentują się statystyki dotyczące inwestycji deweloperskich w okolicy?</p>
                <p>
                    {!!region.stats.properties_flats_top_vendors.length &&
                        `Najwięcej mieszkań na sprzedaż oferuje ${region.stats.properties_flats_top_vendors.map(({name}) => name).join(", ")}. `}
                    Najmniejsze mieszkanie na mapie ma powierzchnię {areaFormat(region.stats.properties_flats_ranges_area_min)}, a największe{" "}
                    {areaFormat(region.stats.properties_flats_ranges_area_max)}.
                    {!!region.stats.average_price_m2 &&
                        `Średnia cena mieszkania ${region.name_declension_where} wynosi ${priceFormat(region.stats.average_price_m2)} za metr kwadratowy`}
                </p>
                <p>Ile kosztują nieruchomości w wybranym regionie?</p>
                <p>
                    {!!region.stats.properties_flats_ranges_price_min &&
                        `Najtańsze mieszkanie kupimy za ${priceFormat(region.stats.properties_flats_ranges_price_min)}. `}

                    {!!region.stats.properties_flats_ranges_price_max &&
                        `Za najdroższy lokal mieszkalny trzeba zapłacić ${priceFormat(region.stats.properties_flats_ranges_price_max)}.`}
                </p>
                <p>Ile gotowych mieszkań jest dostępnych w ofercie deweloperskiej?</p>
                <p>
                    {upperFirst(region.name_declension_where)}{" "}
                    {!!region.stats.properties_flats_count_ready ? (
                        <Fragment>
                            deweloperzy mają {region.stats.properties_flats_count_ready} {flats(region.stats.properties_flats_count_ready)}.
                        </Fragment>
                    ) : (
                        "nie ma mieszkań gotowych do odbioru."
                    )}
                </p>

                <MapGeneratedDescriptionFloors region={region} />
            </Text>
        </Description>
    ) : null;
};

const Description = styled.div<{visible: boolean}>`
    background-color: #fff;
    ${w100};
    min-height: calc(100% - 6.4rem);
    position: absolute;
    top: 0;
    right: 0;
    ${p(4, 3)};
    visibility: ${(props) => (props.visible ? "visible" : "hidden")};
    overflow: auto;
    max-height: 100%;
    z-index: 1;

    @media (min-width: ${(props) => props.theme.breakpoints.md}) {
        min-width: 57.3rem;
        width: 42%;
    }
`;
